import axios, { AxiosRequestConfig } from 'axios';

import { AuthEmail, AuthParams, AuthToken, DataResponse, SsoRequest } from '../types';

const ADMIN_LOGIN_URL = '/v2/public/authenticate/admin';
const EMAIL_LOGIN_URL = '/v2/public/authenticate/email';
const SSO_LOGIN_URL = '/v2/public/sso';

class AuthenticationService {
  static admin(
    data: AuthParams,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AuthToken>> {
    return axios.post(ADMIN_LOGIN_URL, data, config);
  }

  static email(
    data: AuthEmail,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AuthToken>> {
    return axios.post(EMAIL_LOGIN_URL, data, config);
  }

  static sso(data: SsoRequest, config?: AxiosRequestConfig): Promise<DataResponse<AuthToken>> {
    return axios.post(SSO_LOGIN_URL, data, config);
  }
}

export { AuthenticationService };
